// src/components/Header/AdminHeader.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logopro from '../../Images/logo.png';

const AdminHeader = () => {
  const navigate = useNavigate();

  // Función para manejar el cierre de sesión
  const handleLogout = () => {
    localStorage.removeItem('token'); // Elimina el token de localStorage
    navigate('/login'); // Redirige al usuario a la página de inicio de sesión
  };

  return (
    <header className="App-header">
      <img src={logopro} alt="Logo" style={{ width: '200px' }} />
      <nav>
        <ul className="navbar">
          <li><Link to="/cotizaciones">Ver Cotizaciones</Link></li>
          <li><Link to="/crear-producto">Crear Producto</Link></li>
          <li><Link to="/admin-tienda">Administrar Tienda</Link></li>
          <li>
            {/* Botón de Cerrar Sesión */}
            <button onClick={handleLogout} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}>
              Cerrar Sesión
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default AdminHeader;
